@if (infoIdentifiers.length) {
	@if (label && !hideLabel) {
		<p class="form-control-label">{{ label }}</p>
	}
	<app-select [class.validatable-group-control]="!infoRequired" [readOnly]="readOnly" [label]="selectLabel" [placeholder]="selectPlaceholderValue"
			[items]="selectItems" [saveValue]="saveValue" [formControl]="selectControl" (click)="controlClicked()">
	</app-select>
	@if (selectionIdentified) {
		<app-textarea class="validatable-control" debounce [readOnly]="readOnly" [label]="infoLabel" [placeholder]="infoPlaceholderValue"
					[formControl]="infoControl" (click)="controlClicked()" @enterLeave [@.disabled]="readOnly">
		</app-textarea>
	}
}
@else {
	<div class="rounded-border-box">
		<app-select hideBorderBox [readOnly]="readOnly" [label]="label" [placeholder]="selectPlaceholderValue"
				[items]="selectItems" [saveValue]="saveValue" [formControl]="selectControl" (click)="controlClicked()">
		</app-select>
		@if (!readOnly || value?.info) {
			<app-textarea hideBorderBox class="compact" debounce [readOnly]="readOnly" [placeholder]="infoPlaceholderValue"
						[formControl]="infoControl" (click)="controlClicked()">
			</app-textarea>
		}
	</div>
}
